import type { FC } from "react";
import { useLocation } from "react-router";
import { settingsSections } from "../../../features/settingsPage/settingsSections.js";
import {
  useSettingsSectionsPolicy,
  type SettingsSectionKey,
} from "../../../features/settingsPage/settingsSectionsPolicy.js";
import { matchesNavPath, NavigationMenu } from "./navigationMenu.js";
import type { NavigationMenuItemProps } from "./navigationMenuItem.js";

export const SettingsNavigationMenu: FC = () => {
  const { pathname } = useLocation();
  const policy = useSettingsSectionsPolicy();

  // Visibility comes from the shared sections policy; this menu only owns
  // the ordering (the sidebar's groups) and the integrations placement,
  // which moves between the interview-workflow and developers groups
  // depending on the company's integrations variant.
  const orderedSectionKeys: readonly SettingsSectionKey[] = [
    // Account
    "profile",
    "organization",
    "teammates",
    "billing",
    // Interview workflow
    "forms",
    "messageTemplates",
    ...(policy.integrationsNavGroup === "interviewWorkflow"
      ? (["integrations"] as const)
      : []),
    // Call data (recruiting mode) / Workflow (non-recruiting mode)
    "dataExtraction",
    "customFields",
    "keywordTrackers",
    // Call intelligence
    "recording",
    "playbooks",
    "knowledgeBases",
    "signals",
    // Developers
    "webhooks",
    ...(policy.integrationsNavGroup === "developers"
      ? (["integrations"] as const)
      : []),
    "developers",
  ];

  const items: readonly NavigationMenuItemProps[] = orderedSectionKeys
    .filter((key) => policy.sections[key].isInNav)
    .map((key) => {
      const { label, path } = settingsSections[key];
      return {
        label,
        href: path.build(),
        isActive: matchesNavPath(pathname, path.pattern),
      };
    });

  return <NavigationMenu items={items} />;
};
